import {isNil} from 'ramda';

import {GetWarehousesResponse} from '@dms/api/warehouse';

import {Nullish, Unpacked} from 'shared/web';

export const getWarehouseById = (
  warehouses: GetWarehousesResponse | Nullish,
  warehouseId: string | Nullish
): Unpacked<GetWarehousesResponse> | Nullish => {
  if (isNil(warehouses)) {
    return null;
  }
  return warehouses.find((w) => w.id === warehouseId);
};
